import { Flex } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Link } from 'components/mvp-typography';
import { getAppVersion } from 'lib/api/firebase/api-_utils';

import { QuestionnaireIntro } from 'features/patient/assessment/assessment-controller/_components/questionnaire-intro';
import { QAPanelTemplate } from 'features/patient/assessment/assessment-controller/_components/questionnaire-qa-panel';
import { QuestionnaireDataProps } from 'features/patient/assessment/assessment-controller/types';
import { useState } from 'react';
import { prepareImPACTTest } from '../_utils/prepare-impact-test';
import { ImPACTSlice } from '../impactAPISlice';

const TEMP_SAMPLE_PASSPORT_ID = 'DDCFA2TC4SXA';

export function ImpactQuestionnaireIntro(props: {
  impactData: QuestionnaireDataProps;
  impactInfo: ImPACTSlice;
  userId: string;
  /**
   * If this value is set or not undefined the component will
   * try to use the value when creating an ImPACT test URL
   */
  existingPassportId: string | null | -1;
}) {
  const [impactTestUrl, setImpactTestUrl] = useState<string | null>(null);

  async function startImpactQuestionnaire() {
    const testUrl = await prepareImPACTTest(props);
    console.log('[startImpactQuestionnaire]', testUrl);

    if (testUrl) {
      openImPactTest(testUrl);
    }
  }

  function openImPactTest(url: string) {
    setImpactTestUrl(url);
    try {
      window.open(url, '_blank', 'noreferer');
    } catch (e) {
      throw new Error(`Failed to open a new window`);
    }
  }

  /**
   * Handler to skip ImPACT tests
   * @param passportId
   * @returns
   */
  async function fakeImPACTTest(
    passportId: string | null | -1 = TEMP_SAMPLE_PASSPORT_ID
  ) {
    /**
     * If the passport ID is not available, use the sample passport ID
     */
    if (passportId === -1) {
      passportId = TEMP_SAMPLE_PASSPORT_ID;
    }

    if (passportId === null) {
      alert(`No passport ID is set. You must complete`);
      return;
    }

    const url = new URL(
      // !IS_LOCAL_ENDPOINT
      //   ? 'http://127.0.0.1:5001/concussionrx-develop/us-central1/v2/impact/receiveImpactScores' :
      `${process.env.REACT_APP_CLOUD_SERVER}/v2/impact/receiveImpactScores`
    );

    url.searchParams.append('firstName', 'FirstName');
    url.searchParams.append('lastName', 'LastName');
    url.searchParams.append('dateOfBirth', '01/01/0001');
    url.searchParams.append('passportID', passportId);
    url.searchParams.append('testID', '-1');
    url.searchParams.append('testType', 'Post-Injury 1');
    url.searchParams.append('_concussionrx_uid', props.userId);
    url.searchParams.append(
      '_concussionrx_appVersion',
      getAppVersion() ?? 'FATAL: NO APP VERSION SET'
    );

    openImPactTest(url.toString());
  }
  return (
    <Flex vertical gap={16}>
      <QuestionnaireIntro
        data={props.impactData}
        startQuestionnaire={
          /**
           * Trigger the function if:
           * 1. The user has an existing passport ID
           * 2. The user set an existing passport ID
           * 3. THe user did not set an existing passport ID
           */
          props.impactInfo.verified || props.existingPassportId !== null
            ? startImpactQuestionnaire
            : /**
               * TODO: Show an error message
               */
              undefined
        }
      />

      <Flex align="center" vertical gap={16}>
        <QAPanelTemplate>
          <BaseButton onClick={() => fakeImPACTTest(props.existingPassportId)}>
            Skip ImPACT Test
          </BaseButton>
        </QAPanelTemplate>

        {impactTestUrl && (
          <Link href={impactTestUrl}>Page didn&apos;t open? Click here</Link>
        )}
      </Flex>
    </Flex>
  );
}
